import { LOGIN_TYPE, LOGOUT_TYPE } from "../action/type.action"
import { APP_AUTH_TOKEN_NAME, API_SERVERLESS_ENDPOINT } from "../../app.config";
import decode from 'jwt-decode';
import httpClient, { setHttpToken } from "../../service/http.service";

const initialState = {
  token: null,
  data: {},
  isAuthenticate: false
};

function checkToken(token, dispatch) {
  if (token) {
    try {
      // TODO: validate token
      let decodeToken: any = decode(token);
      if (Date.now() / 1000 > decodeToken.exp) {
        // token expired
        localStorage.removeItem(APP_AUTH_TOKEN_NAME);
        dispatch({ type: LOGOUT_TYPE })
        throw new Error('Token expired');
      }
      setHttpToken(token);
      dispatch({
        type: LOGIN_TYPE,
        payload: {
          token: token,
          data: decodeToken
        }
      });
    } catch (error) {
      console.log(error);
      // ignore invalid token
    }
  }
}

export const login = (formData) => async dispatch => {
  try{
  let { data } = await httpClient.post(`${API_SERVERLESS_ENDPOINT}/auth/admin`, formData);
  localStorage.setItem(APP_AUTH_TOKEN_NAME, data)
  checkToken(data, dispatch);
  } catch(error){
    console.log(error)
  }
}

export const checkIdentity = () => async dispatch => {
  let token: string | null = localStorage.getItem(APP_AUTH_TOKEN_NAME);
  checkToken(token, dispatch);
}

export const havePermission = (identity, permissions) => {
  let permission = identity?.permissions.filter((role) => permissions.includes(role));
  return permission && permission.length > 0
}

export const checkPermission = (permission) => {
  
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_TYPE:
      return {
        ...state,
        isAuthenticate: true,
        token: action.payload.token,
        data: action.payload.data
      }
    case LOGOUT_TYPE:
      return {
        token: null,
        isAuthenticate: false,
        data: {}
      }
    default:
      return state
  }
}